// extracted by mini-css-extract-plugin
export default {"link":"AddToCollection_link__pWQg6"};